define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseEngagementWidget = require('web-agent-widgets/BaseEngagementWidget');

    var BaseConnectionsEngagementWidget = BaseEngagementWidget.extend({
        ControllerName: "BaseConnectionsEngagementWidget",
        applicationType: "BaseConnectionsEngagementWidget",

        LPViewMap: {},

        initialize: function (constructorData) {
        },

        events: function () {
        },

        render: function () {
        }
    });

    BaseConnectionsEngagementWidget.prototype.onSelectedEngagementChanged = function (data) {
        BaseEngagementWidget.prototype.onSelectedEngagementChanged.call(this, data);

        data = data || {};

        var newValue = data.newValue || {},
            currentEngagementData = newValue.eventData || {},
            currentEngagementId = lpUtils.getPropertyValueByPath(currentEngagementData, this.itemIdTag); //currentEngagementData[this.itemIdTag];


        if (currentEngagementId) {
            this.activeEngagementId = currentEngagementId;
            this.engagementVC.removeLoading();
            this.engagementVC.updateChatId(currentEngagementId);

            if (!this.modelController.getModelParam('chats.' + currentEngagementId + '.oldChatLine')) {
                this.engagementVC.setLoading(); // in this case we do want to set a loading and invoke the server request for the chat data
                this.modelController.bindModelParam('chats.' + currentEngagementId + '.oldChatLine', onMessagesReady, this);
            }
            this.onEngagementSelected.call(this, currentEngagementId);
        }

        function onMessagesReady() {
            this.modelController.unbindModelParam('chats.' + this.activeEngagementId + '.oldChatLine', onMessagesReady, this);
            this.engagementVC.updateChatId(this.activeEngagementId);
            this.engagementVC.removeLoading();

        }
    };

    BaseConnectionsEngagementWidget.prototype.onSelectedEngagementRemoved = function (data) {
        if (this.activeEngagementId) {
            this.onEngagementCleared.call(this, this.activeEngagementId);
            this.activeEngagementId = null;
        }
    };

    BaseConnectionsEngagementWidget.prototype.onEngagementSelected = function (engagementId) {
    };

    BaseConnectionsEngagementWidget.prototype.onEngagementCleared = function (engagementId) {
    };

    return BaseConnectionsEngagementWidget;

});
